import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Input } from "./Login";
import { toast } from "sonner";

export default function Register() {
    const { register } = useApp();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const u = await register(email, password, name);
            toast.success(`Benvenuto/a in Mini Style, ${u.name}`);
            navigate("/account");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Registrazione non riuscita");
        } finally {
            setSubmitting(false);
        }
    };

    const loginGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/account";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="px-6 py-20 max-w-md mx-auto" data-testid="register-page">
            <div className="overline mb-3">Registrazione</div>
            <h1 className="font-display text-5xl tracking-tight text-[color:var(--ms-charcoal)] mb-3">Crea il tuo account</h1>
            <p className="text-[color:var(--ms-muted)] text-sm mb-10">Ottieni il 10% di sconto sul primo ordine con il codice <span className="text-[color:var(--ms-sage-dark)] font-medium">WELCOME10</span>.</p>
            <form onSubmit={onSubmit} className="space-y-5">
                <Input label="Nome" value={name} onChange={setName} testid="register-name" />
                <Input label="Email" type="email" value={email} onChange={setEmail} testid="register-email" />
                <Input label="Password" type="password" value={password} onChange={setPassword} testid="register-password" />
                <button type="submit" disabled={submitting} className="w-full bg-[color:var(--ms-charcoal)] text-[color:var(--ms-warm-white)] py-4 text-xs tracking-[0.22em] font-medium hover:bg-[color:var(--ms-sage-dark)] transition-colors disabled:opacity-50" data-testid="register-submit">
                    {submitting ? "CREAZIONE…" : "CREA ACCOUNT"}
                </button>
            </form>
            <div className="flex items-center gap-3 my-8 text-[color:var(--ms-muted)] text-xs tracking-[0.2em]">
                <span className="flex-1 border-t border-[color:var(--ms-border)]" /> OPPURE <span className="flex-1 border-t border-[color:var(--ms-border)]" />
            </div>
            <button onClick={loginGoogle} className="w-full border border-[color:var(--ms-charcoal)] text-[color:var(--ms-charcoal)] py-4 text-xs tracking-[0.22em] hover:bg-[color:var(--ms-charcoal)] hover:text-[color:var(--ms-warm-white)] transition-colors" data-testid="register-google">
                CONTINUA CON GOOGLE
            </button>
            <p className="text-center mt-8 text-sm text-[color:var(--ms-muted)]">
                Hai già un account? <Link to="/login" className="text-[color:var(--ms-sage-dark)] link-underline" data-testid="register-login-link">Accedi</Link>
            </p>
        </div>
    );
}
